import React from 'react';
import { cn } from '@/lib/utils';
import { Router } from 'lucide-react';

interface ConnectionBadgeProps {
    isOnline: boolean;
    className?: string;
}

export function ConnectionBadge({ isOnline, className }: ConnectionBadgeProps) {
    return (
        <div className={cn("flex items-center space-x-2", className)}>
            <Router className={cn("h-4 w-4", isOnline ? "text-primary" : "text-danger")} />
            <span className={cn(
                "paragraph-11 capitalize font-inter",
                isOnline ? "text-primary" : "text-danger"
            )} style={{ fontFamily: 'Inter, sans-serif !important' }}>
                {isOnline ? 'Online' : 'Offline'}
            </span>
        </div>
    );
}